import { useState } from "react";
import { adminLogin } from "../utils/api";
import "./admin.css";
import { isLoggedIn } from "../utils/auth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
if (isLoggedIn()) {
  return <Navigate to="/" replace />;
}
  const login = async () => {
    if (!email || !password) {
      alert("Please enter email and password");
      return;
    }

    try {
      setLoading(true);
      const data = await adminLogin(email, password);
      localStorage.setItem("token", data.token);
      localStorage.setItem("expiresAt", data.expiresAt);
      window.location.href = "/";
    } catch (e) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
        
      <div className="login-card">
        <div className="brand">
          <img
            src="/images/logo.png"
            alt="Oz Vehadar Logo"
            className="brand-logo"
          />
          {/* <span className="login-title">Oz Vehadar</span> */}
        </div>
        <h1 className="login-title">Admin Login</h1>
        <p className="login-subtitle">
          Sign in to manage Oz Vehadar users
        </p>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="admin@ozvehadar.org"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          className="login-btn"
          onClick={login}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </div>
    </div>
  );
}
